<template>
    <div ref="slot" class="common-calendarx-event">
        <div :class="titleClass">
            {{ calendarEvent.title }}
            <span>({{ startTime }} - {{ endTime }})</span>
        </div>
        <span v-if="showFullData" :class="addressClass">
            {{ address }}
        </span>
        <div :class="userClass">
            <common-user-avatar :user="calendarEvent.initiator" :size="iconSize"></common-user-avatar>
            <span>{{ calendarEvent.initiator.firstName }} {{ calendarEvent.initiator.lastName }}</span>
        </div>
        <div v-for="oc in offerCategories" :key="oc" :class="categoryClass">{{ oc }}</div>
    </div>
</template>

<script>
    import TranslateMixin from 'mixins/TranslateMixin'

    import availabilityTransformer from 'transformers/availabilityTransformer'

    export default {
        mixins: [TranslateMixin],

        props: {
            calendarEvent: { type: Object, required: true },
            showFullData: { type: Boolean, default: false },
        },

        computed: {
            startTime() {
                return availabilityTransformer.minutesDateToLocalTZTime(this.calendarEvent.startTime, this.calendarEvent.date)
            },

            endTime() {
                return availabilityTransformer.minutesDateToLocalTZTime(
                    this.calendarEvent.allowOverlapAfterMinutes
                        ? this.calendarEvent.startTime + this.calendarEvent.allowOverlapAfterMinutes
                        : this.calendarEvent.endTime,
                    this.calendarEvent.date,
                )
            },

            duration() {
                return this.calendarEvent.endTime - this.calendarEvent.startTime
            },

            offerCategories() {
                return this.calendarEvent?.calendarEventItems?.map((ci) => this.getTranslation(ci.offerCategory.titleTextContent))
            },

            address() {
                return `${this.calendarEvent?.availabilityOffer?.linkedOffer?.location?.address}, ${this.calendarEvent?.availabilityOffer?.linkedOffer?.location?.city.name}`
            },

            titleClass() {
                return {
                    [`common-calendarx-event__title`]: true,
                    [`common-calendarx-event__title--detail`]: this.showFullData,
                }
            },

            addressClass() {
                return {
                    [`common-calendarx-event__address`]: this.showFullData,
                }
            },

            userClass() {
                return {
                    [`common-calendarx-event__user`]: true,
                    [`common-calendarx-event__user--detail`]: this.showFullData,
                }
            },

            iconSize() {
                return this.showFullData ? 'small' : 'micro'
            },
            categoryClass() {
                return {
                    [`common-calendarx-event__category`]: true,
                    [`common-calendarx-event__category--detail`]: this.showFullData,
                }
            },
        },

        methods: {
            calculateHeight() {
                const pixelsPerMinute = 66.667 / 60
                const height = this.duration * pixelsPerMinute
                this.$refs.slot.style.height = `${height}px`
            },
        },

        mounted() {
            if (!this.showFullData) {
                this.calculateHeight()
            }
        },
    }
</script>

<style lang="scss" scoped>
    @import 'styles/setup/_variables.scss';
    @import 'styles/setup/_mixins.scss';
    .common-calendarx-event {
        background-color: #eaddff;
        border: 1px solid white;
        border-radius: 5px;
        border-left: 5px solid #6750a4;
        border-top: 1px solid #d3beef;
        color: #21005e;
        padding: 0 10px;
        cursor: pointer;

        &__title {
            font-weight: 600;
            span {
                font-weight: 500;
            }
            &--detail {
                font-size: $font-size--heading-small;
            }
        }
        &__address {
            font-size: $font-size--header-copy;
        }

        &__user {
            display: flex;
            align-items: center;
            line-height: 18px;
            span {
                margin-left: 5px;
            }
            &--detail {
                font-size: $font-size--base;
            }
        }

        &__category {
            display: list-item;
            margin-left: 1em;
            color: #6d6491;
            font-size: $font-size--small;
            &--detail {
                font-size: $font-size--form;
            }
        }
    }
</style>
